export var REQUEST_DATA_REQUEST = '/src/dataAndPrivacy/REQUEST_DATA_REQUEST';
export var REQUEST_DATA_SUCCESS = '/src/dataAndPrivacy/REQUEST_DATA_SUCCESS';
export var REQUEST_DATA_FAILURE = '/src/dataAndPrivacy/REQUEST_DATA_FAILURE';
export var TERMS_REQUEST = '/src/dataAndPrivacy/REQUEST_TERMS_REQUEST';
export var TERMS_SUCCESS = '/src/dataAndPrivacy/REQUEST_TERMS_SUCCESS';
export var TERMS_FAILURE = '/src/dataAndPrivacy/REQUEST_TERMS_FAILURE';
export var TERM_LATEST_REQUEST = '/src/dataAndPrivacy/TERM_LATEST_REQUEST';
export var TERM_LATEST_SUCCESS = '/src/dataAndPrivacy/TERM_LATEST_SUCCESS';
export var TERM_LATEST_FAILURE = '/src/dataAndPrivacy/TERM_LATEST_FAILURE';
export var POLICIES_REQUEST = '/src/dataAndPrivacy/POLICIES_REQUEST';
export var POLICIES_SUCCESS = '/src/dataAndPrivacy/POLICIES_SUCCESS';
export var POLICIES_FAILURE = '/src/dataAndPrivacy/POLICIES_FAILURE';
export var POLICY_LATEST_REQUEST = '/src/dataAndPrivacy/POLICY_LATEST_REQUEST';
export var POLICY_LATEST_SUCCESS = '/src/dataAndPrivacy/POLICY_LATEST_SUCCESS';
export var POLICY_LATEST_FAILURE = '/src/dataAndPrivacy/POLICY_LATEST_FAILURE';
